import * as S from "./PopupAlert.style";

interface PopupAlertProps {
  title?: string;
  text?: string;
  subText?: string;
  buttons?: React.ReactElement;
}

export const PopupAlert = ({
  title,
  text,
  subText,
  buttons,
}: PopupAlertProps) => {
  return (
    <S.PopupAlertBox>
      <S.PopupAlert>
        <S.PopupTitle $subText={subText ? true : false}>{title}</S.PopupTitle>

        {subText ? (
          <S.PopupContentBox>
            <S.PopupContent $subText={subText ? true : false}>
              {text}
            </S.PopupContent>
            <S.PopupSubContent>{subText}</S.PopupSubContent>
          </S.PopupContentBox>
        ) : (
          <S.PopupContent>{text}</S.PopupContent>
        )}

        <S.PopupButtons>{buttons}</S.PopupButtons>
      </S.PopupAlert>
    </S.PopupAlertBox>
  );
};
